<template>

  <div class="user">


    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
       

        <el-form-item label="">
          <el-input v-model="formInline.buser_search" placeholder="请输入名称/昵称"></el-input>
        </el-form-item>


        <el-form-item label="类型">
          <el-select size="small" v-model="formInline.code" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="门店" value="store"></el-option>
            <el-option label="业务员" value="salesperson"></el-option>
          </el-select>
        </el-form-item>

        
        <el-form-item label="审核状态">
          <el-select size="small" v-model="formInline.status" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="未审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>

          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="primary" @click="sync('store')">同步门店</el-button>
          <!-- <el-button type="primary" @click="sync('salesperson')">同步业务员</el-button>
          <el-button type="primary" @click="sync('user')">同步用户</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="oioc_id" label="ID" > </el-table-column>
            <el-table-column prop="name" label="名称" > </el-table-column>
            <el-table-column prop="native_user_id" label="关联一物一码用户ID" > </el-table-column>
            <el-table-column prop="user_id" label="用户ID" > </el-table-column>
            <el-table-column prop="code" label="类型" > 
              <template slot-scope="scope">
              <span v-if="scope.row.code=='store'">门店</span>
              <span v-if="scope.row.code=='salesperson'">业务员</span>
              <span v-if="scope.row.code=='user'">用户</span>
            
            </template>
          </el-table-column>
            <el-table-column prop="mobile" label="手机号" > </el-table-column>
        
            <el-table-column prop="status" label="审核状态" > 
              <template slot-scope="scope">
                  <span v-if="scope.row.status==0">未审核</span>
                  <span v-if="scope.row.status==1">审核通过</span>
            
            </template>

            </el-table-column>
    

            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="apiClick(scope.row.user_id)" type="text" size="small" 
              >api</el-button>
              <el-button @click="userClick(scope.row.user_id)" type="text" size="small" 
              >用户</el-button>
             </template>
          </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OiocApi from '@/api/oioc.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        buser_search:"",
        order_search:"",
        user_search:"",
        is_ratio:-1,
        code:"",
        status:-1,
      },
      app_id:""


    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
    apiClick(user_id){
      this.$router.push({
        path: '/plus/api/app',
        query: {
          user_id: user_id
        }
      });
    },
    userClick(user_id){
      this.$router.push({
        path: '/user/user/index',
        query: {
          user_id: user_id
        }
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      console.log("------")
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;

      OiocApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.app_id = data.data.app_id;
        })
        .catch(error => {});
    },
    sync(code){
        //跳转同步页面
        if(this.app_id.lengtn <= 0){
          this.$message({
              message: '系统错误，请稍后再试',
              type: 'success'
            });  
          return;
        }
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let url = baseUrl + '/job/Sync/run?app_id='+this.app_id+"&code="+code;
        window.open(url)
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },



  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/oioc/index/index.vue